import http from '@/core/http'
// import { map } from 'lodash'

const url = 'produtos/limite-risco'

const state = {
  itens: [],
  item: {
  },
  modalidades: [],
  totalItens: 0
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, { params: payload })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete(url, {params: payload})
    return Promise.resolve(result)
  },

  getItem: ({ commit }, payload) => {
    commit('LISTA_ITEM', payload)
  },

  getModalidades: async ({ commit }, payload) => {
    const result = await http.get(`${url}/modalidades`, {params: payload})
    commit('LISTA_MODALIDADES', result.data)
    return Promise.resolve(result)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  }
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM' (state, payload) {
    state.item = Object.assign({}, payload)
  },

  'LIMPAR_ITEM' (state) {
    state.item = {
    }
  },

  'LISTA_MODALIDADES' (state, payload) {
    state.modalidades = payload.resultMap
  },
}

const getters = {
  listaItens: state => state.itens,
  listaModalidades: state => state.modalidades,
  totalItens: (state) => state.totalItens,
  item: state => state.item,
}

export default { namespaced: true, state, actions, mutations, getters }